// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@awc/XDL/Utilities";
import { autocompleteProductsStyles } from "@insite/content-library/Widgets/Header/AutocompleteProducts";
import { css } from "styled-components";

autocompleteProductsStyles.titleLink = {
    typographyProps: {
        ellipsis: true,
        css: css`
            &&& {
                width: 100%;
                text-align: left;
                margin: 0;
                color: ${color("common.ui14")};
                &:hover {
                    color: ${color("common.ui8")};
                }
            }
        `,
    },
    css: css`
        width: 230px;
    `,
};

autocompleteProductsStyles.erpNumberText = {
    ellipsis: true,
    css: css`
        width: 230px;
        text-align: left;
        margin: 5px 0 0 0;
    `,
};

autocompleteProductsStyles.headerText = {
    weight: "bold",
    css: css`
        text-align: left;
        margin: 10px 0 5px 0;
        display: inline-block;
    `,
};
